// extracted by mini-css-extract-plugin
export default {"Text":"SummaryCard_Text__MQmGn","Figures":"SummaryCard_Figures__VXcqK","Shadow":"SummaryCard_Shadow__Nl+1C"};